import { Component, Input, OnDestroy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../../directives/rtldiv-directive.directive';
import { Chart, ChartModule } from 'angular-highcharts';
import { TranslatorService } from '../../../../services/translator_service';
import { ResponsiveService } from '../../../../services/responsive.service';
import { ApiQuery } from '../../../../web-services/api/api.query';
import _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-bin-collection-pie',
  standalone: true,
  imports: [TranslateModule, RTLDivDirectiveDirective,ChartModule],
  templateUrl: './bin-collection-pie.component.html',
  styleUrl: './bin-collection-pie.component.scss'
})
export class BinCollectionPieComponent implements OnDestroy {
	isMobile: boolean;
	donutChart: any;
	translationsObj;
	currentLang;
	thresholdRange: [number, number, number, number,number,number];
	selectedBinInfo: any = null;
	private readonly destroy$ = new Subject<void>();

	constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,private apiQuery:ApiQuery) {
	}

	ngOnInit() {
		this.onResize();
		this.responsiveService.checkWidth();

		this.apiQuery.binInfo$.pipe(takeUntil(this.destroy$)).subscribe((info) => {
			if (!info) {
				return;
			}
			this.selectedBinInfo = info;

			this.thresholdRange = [
			0,
			parseFloat((this.selectedBinInfo?.Bin_thresholds.green_status_fill_level_in_percent/2).toFixed(0)),
			this.selectedBinInfo?.Bin_thresholds.green_status_fill_level_in_percent,
			parseFloat(((this.selectedBinInfo?.Bin_thresholds.yellow_status_fill_level_in_percent + this.selectedBinInfo?.Bin_thresholds.green_status_fill_level_in_percent)/2).toFixed(0)),
			this.selectedBinInfo?.Bin_thresholds.yellow_status_fill_level_in_percent,
			this.selectedBinInfo?.Bin_thresholds.red_status_fill_level_in_percent,
			];			
			this.updateChart();
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

  	onResize() {
		this.responsiveService.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}

	updateChart(){
		this.apiQuery.binCollectionData$.pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
			if(data.length==0) return;			
			let total = 0;
			let firstPart = 0;
			let secondPart = 0;
			let thirdPart = 0;
			let forthPart = 0;
			let fifthPart = 0;
			if (!_.isEmpty(data[0])){
				_.each(data, (item) => {
					if(item.bin_fill_level_before_collection > this.thresholdRange[0] && item.bin_fill_level_before_collection <= this.thresholdRange[1]){
						firstPart ++;
					}else if(item.bin_fill_level_before_collection > this.thresholdRange[1] && item.bin_fill_level_before_collection <= this.thresholdRange[2]){
						secondPart ++;
					}else if(item.bin_fill_level_before_collection > this.thresholdRange[2] && item.bin_fill_level_before_collection <= this.thresholdRange[3]){
						thirdPart ++;
					}else if(item.bin_fill_level_before_collection > this.thresholdRange[3] && item.bin_fill_level_before_collection <= this.thresholdRange[4]){
						forthPart ++;
					}else if(item.bin_fill_level_before_collection > this.thresholdRange[4] && item.bin_fill_level_before_collection <= this.thresholdRange[5]){
						fifthPart ++;
					}
				});
				total = data.length;
			}
			this.initDonut(total,firstPart,secondPart,thirdPart,forthPart,fifthPart);
		}); 	
	}

	initDonut(total,firstPart,secondPart,thirdPart,forthPart,fifthPart) {
		this.translator.currentLangEmitter$
		.pipe(takeUntil(this.destroy$))
		.subscribe(async value=>{						
			this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
			this.currentLang = value;
			const donut = new Chart({
				chart: {
					marginTop: 0,
					marginBottom: 0,
					marginLeft: 0,
					marginRight: 0,
					plotBackgroundColor: null,
					plotBorderWidth: 0,
					plotShadow: false
				},
				legend: {
					align: 'center',
					layout: 'vertical',	
					itemMarginBottom: 5,
					verticalAlign: 'middle',
					x: 185,
					itemStyle: {
						fontFamily:'Open Sans',
						fontSize:'14px',
						color:'#3A4743',
						fontWeight: 'normal'				
					},	
				},
				title:{
					text: `
						<div style='font-family: Open Sans, sans-serif;font-weight: 600;font-size: 32px;color: #2A3338'> ${total} </div> 
						<br> 
						<div style='font-family: Open Sans, sans-serif;font-weight: 600;font-size: 14px;color: #2A3338'>${this.translationsObj.TITLES.ACTUAL_CLEARING}</div>`,
					align: 'center',
					verticalAlign: 'middle'
				},
				tooltip: {	
					borderWidth:0,
					backgroundColor:null,
					useHTML: true,	
					formatter: function(){
						return `
						    <div style='align-items: center;padding: 4px 8px;width: max-content;height: max-content;top: 85px;background: #F5F6FA;box-shadow: 0px 2px 8px rgba(93, 120, 112, 0.2);border-radius: 3px;display: flex;gap: 6px;'>
								<img src='../../../assets/images/dashboard/bin.svg' alt=''/>
								<div style='flex-direction: column;gap: 2px;display: flex;'>
									<div style='font-family: Open Sans;font-weight: 400;font-size: 14px;color: #2A3338'>
										${this.point.name}
									</div>
									<div style='font-family: Open Sans;font-weight: 600;font-size: 14px;color: #2A3338'>
										${this.point.y} (${parseInt(this.point.percentage.toString())}%)
									</div>
								</div>
							</div>
						`;										
					  }
				},
				credits: {
				  enabled: false
				},
				plotOptions: {
				  pie: {
					allowPointSelect: false,
					cursor: "pointer",
					dataLabels: {
					  enabled: false
					},
					center: ["50%", "50%"],
					size: "100%",
					showInLegend: true
				  }
				},
				series: [
				  {
					name: "",
					point: {
						events: {
							legendItemClick: function() {
								return false;
							}
						}
					},
					data: [
					  {
						name: this.thresholdRange[0].toString()+"%"+"-"+this.thresholdRange[1].toString()+"%",
						color: '#A7E8C4',
						y: firstPart
					  },
					  {
						name: (this.thresholdRange[1]+1).toString()+"%"+"-"+this.thresholdRange[2].toString()+"%",
						color: '#28B365',
						y: secondPart
					  },
					  {
						name: (this.thresholdRange[2]+1).toString()+"%"+"-"+this.thresholdRange[3].toString()+"%",
						color: '#FFD654',
						y: thirdPart
					  },
					  {
						name: (this.thresholdRange[3]+1).toString()+"%"+"-"+this.thresholdRange[4].toString()+"%",
						color: '#FAB300',
						y: forthPart
					  },
					  {
						name: (this.thresholdRange[4]+1).toString()+"%"+"-"+this.thresholdRange[5].toString()+"%",
						color: '#FF4E3E',
						y: fifthPart
					  }
					],
					type: "pie",
					innerSize: "50%"
				  }
				]
			  });
			  this.donutChart = donut;
		})
	}
}
